import { createSlice } from "@reduxjs/toolkit"

interface SplashState {
  isVisible: boolean
  hasShown: boolean
}

const initialState: SplashState = {
  isVisible: true,
  hasShown: false,
}

const splashSlice = createSlice({
  name: "splash",
  initialState,
  reducers: {
    hideSplash: (state) => {
      state.isVisible = false
      state.hasShown = true
    },
    showSplash: (state) => {
      state.isVisible = true
    },
    resetSplash: (state) => {
      state.isVisible = true
      state.hasShown = false
    },
  },
})

export const { hideSplash, showSplash, resetSplash } = splashSlice.actions
export default splashSlice.reducer